<script setup lang="ts">
import { Price } from '@commercetools/platform-sdk';
import { money } from '@nuts/auto-delivery-sdk/dist/utils/format';
import { computed } from 'vue';

import Header5 from '@/components/base/typography/Header5.vue';
import SmallBodyText from '@/components/base/typography/SmallBodyText.vue';
import { getListPrice, getMoneyValue } from '@/lib/product/prices';
import { LineSavingsSummary, Money } from '@/utils/money';

const props = defineProps<{
  /** Optional in CT but expected to be required in practice */
  prices?: Price[];
  quantity: number;
  totalPriceBeforeCartLevelDiscount: Money;
  totalSavings?: LineSavingsSummary;
}>();

const totalListPriceBeforeCartLevelDiscount = computed(() => {
  const listPrice = getListPrice(props.prices!);
  const value = getMoneyValue(listPrice, props.quantity);

  return Money.multiply(value, props.quantity);
});
</script>

<template>
  <div class="flex flex-wrap gap-x-2 items-end md:justify-end" data-test="inline-product-price">
    <span v-if="totalSavings" class="sr-only">Discounted price of </span>
    <Header5 :class="totalSavings?.onSale ? 'text-nuts-red-800' : 'text-nuts-neutral-800'">
      {{ money(totalPriceBeforeCartLevelDiscount) }}
    </Header5>
    <span v-if="totalSavings" class="sr-only">Price without discount</span>
    <SmallBodyText
      v-if="totalSavings"
      class="line-through text-nuts-neutral-800"
      data-test="strike-through-price"
    >
      {{ money(totalSavings?.comparisonPrice ?? totalListPriceBeforeCartLevelDiscount) }}
    </SmallBodyText>
  </div>
</template>
